import { FC } from "react";
import { Container, Row, Col } from "react-bootstrap";
import styles from "./AboutSection.module.css";

const AboutSection: FC = () => {
  return (
    <section className={styles.about}>
      <Container>
        <Row className="align-items-center">
          <Col lg={6} className={styles.imageCol}>
            <img
              src="/africa.jpg"
              alt="Africa"
              className={styles.aboutImage}
            />
          </Col>
          <Col lg={6}>
            <h2 className={styles.title}>Rethinking outsourcing</h2>
            <p className={styles.description}>
              With Danish senior tech leadership, we work directly with you on
              every engagement. With our team in Rwanda, we scale to fit your
              needs. All without cultural barriers or time zone challenges.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;
